import { useParams } from "react-router-dom";
import AuthCardContainer from "../../components/Auth/AuthCardContainer/AuthCardContainer";
import LoginForm from "../../components/Auth/LoginForm/LoginForm";
import LoginTemporary from "../../components/Auth/LoginTemporary/LoginTemporary";
import ExtensionService from "../../services/extension.service";
import { useCallback, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";

const extensionConfig = new ExtensionService();

const LoginPage = () => {
  const { type } = useParams();

  const [loginHeaderText, setLoginHeaderText] = useState("");

  const { sendRequest: extensionConfigRequest } = useFetch(
    extensionConfig.getExtensionConfig,
  );

  const getLoginHeaderText = useCallback(async () => {
    const { data, success } = await extensionConfigRequest({
      Identifier: "LoginHeaderText",
      ExtensionCode: "23",
    });
    if (success) {
      setLoginHeaderText(data[0].value);
    }
  }, [extensionConfigRequest]);

  useEffect(() => {
    if (type) {
      getLoginHeaderText();
    }
  }, [getLoginHeaderText, type]);

  if (type) {
    return (
      <>
        <AuthCardContainer loginHeaderText={loginHeaderText}>
          <LoginTemporary />
        </AuthCardContainer>
      </>
    );
  }

  return (
    <AuthCardContainer>
      <LoginForm />
    </AuthCardContainer>
  );
};

export default LoginPage;
